import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row cart-checkout__thankyou" };
const _hoisted_2 = { class: "col-md-8 mx-auto text-left mt-2" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
    class: "h5 mt-4 ml-0 mr-0",
    style: { "display": "flex", "flex-direction": "row" }
};
const _hoisted_5 = {
    key: 0,
    class: "spinner ms-2"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce1" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce2" }, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce3" }, null, -1);
const _hoisted_9 = [
    _hoisted_6,
    _hoisted_7,
    _hoisted_8
];
const _hoisted_10 = {
    key: 1,
    class: "ms-2"
};
const _hoisted_11 = { class: "mt-4" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = { class: "mt-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, [
                _createElementVNode("span", {
                    innerHTML: _ctx.schema?.options?.caption
                }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, _toDisplayString(_ctx.schema?.options?.text_Cart) + ": ", 1),
                _createElementVNode("div", null, [
                    (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.cart?.cartNumber), 1))
                ])
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", {
                    innerHTML: _ctx.schema?.options?.description
                }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.BackToHome')), 1)
                    ]),
                    _: 1
                })
            ])
        ])
    ]));
}
